import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { useForm } from "react-hook-form";
import { DBCitySearchReturnDetails } from "../Common/Ui/DBCitySearchReturnDetails";
import { joiResolver } from "@hookform/resolvers/joi";
import Joi from "joi";
import { ErrorText } from "../errors/ErrorText";
import DatePicker from "react-date-picker";
import { getAuthToken } from "../../commonGlobals/functions/localStorage/getUser";
import { appAxios } from "../../axios/axios";
import { toast } from "react-toastify";
import ReCaptcha from "../Common/Ui/ReCaptcha";
import CreateNewAgent from "../FlightEnquiryForm/CreateNewAgent";
import { AdultChildDetails } from "../Common/AdultChildDetails";
import { IHotelEnquiry } from "../types/flights";
import moment from "moment";
import { LoadingButton } from "../Common/Ui/LoadingButton";
import { CustomInput } from "../Common/Ui/CustomInput";
import { CustomStaticSelect } from "../Common/Ui/CustomStaticSelect";
import { useLocation, useNavigate } from "react-router-dom";
const CustomCkEditor = React.lazy(() => import("../Common/Ui/CustomCkEditor"));

const hotelSchema = Joi.object({
  city: Joi.string().required().label("City"),
  rooms: Joi.number().required().min(1).label("Rooms"),
  noOfAdult: Joi.number().required().min(1).label("Adult"),
  noOfChild: Joi.number().required().min(0).label("Child"),
  noOfInfant: Joi.number().required().min(0).label("Infant"),
  checkin: Joi.date().required().label("Checkin Date"),
  checkout: Joi.date().required().label("Checkout Date"),
  isFlexible: Joi.boolean().optional().allow(null).label("Is Flexible"),
  category: Joi.string().required().label("Hotel Category"),
  remark: Joi.string().trim().required().label("Remark"),
  type: Joi.string().trim().required().label("Type"),
  hotelName: Joi.string().optional().allow(null, "").label("Hotel Name"),
});

const defaultValues: IHotelEnquiry = {
  checkin: undefined,
  checkout: undefined,
  isFlexible: false,
  city: undefined,
  rooms: 1,
  noOfAdult: 1,
  noOfChild: 0,
  noOfInfant: 0,
  category: "All",
  remark: undefined,
  type: "Hotel Enquiry",
  hotelName: null,
};

const HotelsQueryForm: React.FC<{
  onBehalfByStaff?: boolean;
  userData?: any;
  onSaveEnquiry?: any;
  onEditSave?: () => void;
}> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const hotelData: IHotelEnquiry = location?.state?.enquiryData;
  const enquiryId: number = location?.state?.enquiryId;
  const isUpdating = hotelData ? true : false;
  // const [captchaToken, setCaptchaToken] = useState<string | undefined>(
  //   undefined
  // );
  const [additionDetailsOldState, setAdditionDetailsOldState] = useState<{
    rooms: number | undefined;
    category: string;
  }>({
    rooms: 1,
    category: "All",
  });
  // const reCaptchaRef = useRef<any>();
  const [passengerPopup, setPassengerPopup] = useState(false);
  const [showCreateNewUserPopUp, setShowCreateNewUserPopUp] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [resetAdultChildInfant, setResetAdultChildInfant] = useState(false);
  const isLoogedIn = getAuthToken();

  const {
    handleSubmit,
    register,
    watch,
    trigger,
    formState,
    setValue,
    reset,
    getValues,
  } = useForm<IHotelEnquiry>({
    resolver: joiResolver(hotelSchema),
    defaultValues: hotelData ? hotelData : defaultValues,
  });

  const saveEnquiry = async (enquiryData: IHotelEnquiry) => {
    if (!isLoogedIn) {
      return setShowCreateNewUserPopUp(true);
    }
    const data = {
      ...enquiryData,
      checkin: moment(enquiryData.checkin).format("YYYY-MM-DD"),
      checkout: moment(enquiryData.checkout).format("YYYY-MM-DD"),
    };

    setRequestLoading(true);
    try {
      const url = "/query/saveHotelEnquiry";
      const dataToBeSend = props.onBehalfByStaff
        ? {
            enquiryData: data,
            userData: props.userData && props.userData,
            isOnBehalf: props.onBehalfByStaff,
          }
        : {
            enquiryData: data,
          };
      const saveResponse = await appAxios(url, {
        method: "POST",
        data: dataToBeSend,
      });

      if (saveResponse.data.success) {
        setValue("remark", undefined);
        reset(defaultValues);
        setResetAdultChildInfant(true);
        props.onSaveEnquiry && props.onSaveEnquiry();
        toast.success("Enquiry saved successfully");
      }
    } catch (error: any) {
      const errorMessage = "Unable to save enquiry!!";
      toast.error(errorMessage);
    } finally {
      setRequestLoading(false);
    }
  };
  const updateEnquiry = async (enquiryData: IHotelEnquiry) => {
    const data = {
      ...enquiryData,
      checkin: moment(enquiryData.checkin).format("YYYY-MM-DD"),
      checkout: moment(enquiryData.checkout).format("YYYY-MM-DD"),
    };
    setRequestLoading(true);
    try {
      const updateResponse = await appAxios("/query/updateEnquiry", {
        method: "POST",
        // headers: {
        //   "captcha-token": captchaToken ? captchaToken : token,
        // },
        data: {
          enquiryData: {
            id: enquiryId,
            ...data,
          },
        },
      });
      if (updateResponse.data.success) {
        toast.success("Enquiry updated successfully");
        navigate(`/enquiry/${enquiryId}`, {
          replace: true,
        });
      }
    } catch (error) {
      const errorMessage = "Unable to update enquiry!!";
      toast.error(errorMessage);
    }
    setRequestLoading(false);
  };

  const formData = watch();

  const errors = formState.errors;

  return (
    <>
      <div className="tab-pane active p-4">
        <div className="module-name">
          <h3 className="after-heading">Hotel Enquiry</h3>
          <p>Book Domestic and International hotels Online. </p>
        </div>

        <form
          onSubmit={
            isUpdating ? handleSubmit(updateEnquiry) : handleSubmit(saveEnquiry)
          }
        >
          <div className="row mb-2">
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="form-group with-icon">
                <label className=" mb-0">Select City</label>
                <DBCitySearchReturnDetails
                  value={
                    getValues("city") && getValues("city")!.length > 0
                      ? getValues("city")
                      : undefined
                  }
                  onChange={(city) => {
                    if (city) {
                      setValue("city", city.label);
                    } else {
                      setValue("city", "");
                    }
                  }}
                  error={errors.city?.message}
                />
                <ErrorText error={errors.city?.message} />
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="form-group with-icon">
                <label className=" mb-0">Checkin</label>
                <DatePicker
                  className="bg-light w-100 form-control"
                  value={getValues("checkin")}
                  clearIcon={null}
                  onChange={(date) => {
                    setValue("checkin", date);
                  }}
                  format="dd-MM-y"
                  dayPlaceholder="DD"
                  monthPlaceholder="MM"
                  yearPlaceholder="YYYY"
                  minDate={new Date()}
                />
                <ErrorText error={errors.checkin?.message} />
              </div>
            </div>
            <div
              className="col-lg-3 col-md-6"
              style={{
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "0px",
                  right: "16px",
                }}
              >
                <label
                  htmlFor="flexible-date"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  Flexible
                </label>
                <input
                  style={{
                    cursor: "pointer",
                  }}
                  type="checkbox"
                  className="form-check-input ms-2 border-0"
                  id="flexible-date"
                  checked={getValues("isFlexible")}
                  onChange={(e) => {
                    setValue("isFlexible", e.target.checked);
                  }}
                />
              </div>
              <div className="form-group with-icon">
                <label className=" mb-0">Checkout</label>

                <DatePicker
                  className="bg-light w-100 form-control"
                  value={getValues("checkout")}
                  clearIcon={null}
                  onChange={(date) => {
                    setValue("checkout", date);
                  }}
                  format="dd-MM-y"
                  defaultValue={getValues("checkin")}
                  dayPlaceholder="DD"
                  monthPlaceholder="MM"
                  yearPlaceholder="YYYY"
                  minDate={getValues("checkin") || new Date()}
                />
                <ErrorText error={errors.checkout?.message} />
              </div>
            </div>
            <div className="col-lg-3">
              <CustomInput
                label="Hotel Name(Optional)"
                register={register}
                name="hotelName"
                type="text"
                id="hotel_name"
                placeholder="Raddisson"
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="mb-3 col-lg-6 col-12">
              <label>Remark</label>

              <CustomCkEditor
                data={getValues("remark")}
                onChange={(data) => {
                  setValue("remark", data);
                }}
              />
              <ErrorText error={errors.remark?.message} />
            </div>
            <div className="col-lg-3 col-md-6">
              <AdultChildDetails
                label="Additional Details"
                paxInfo={{
                  adult: getValues("noOfAdult") || 1,
                  child: getValues("noOfChild") || 0,
                  infant: getValues("noOfInfant") || 0,
                }}
                show={passengerPopup}
                onOpen={() => {
                  setPassengerPopup(true);
                  setAdditionDetailsOldState({
                    rooms: getValues("rooms"),
                    category: getValues("category"),
                  });
                }}
                onClose={async () => {
                  setValue("rooms", additionDetailsOldState.rooms);
                  setValue("category", additionDetailsOldState.category);
                  setPassengerPopup(false);
                }}
                onSave={async (paxInfo) => {
                  setValue("noOfAdult", paxInfo.adult);
                  setValue("noOfChild", paxInfo.child);
                  setValue("noOfInfant", paxInfo.infant);
                  const result = await trigger("rooms");
                  if (result) {
                    setPassengerPopup(false);
                  }
                }}
                // this is jugad for this component to reset adult child infant will fix this later
                reset={resetAdultChildInfant}
                afterReset={() => {
                  setResetAdultChildInfant(false);
                }}
              >
                <div className="row">
                  <div className="col-6">
                    <CustomInput
                      label="Rooms"
                      labelClassname="text-secondary"
                      type="number"
                      id="room_count"
                      className={`py-2 ${
                        !getValues("rooms") ? "border-danger" : ""
                      }`}
                      placeholder="1"
                      required
                      min={1}
                      value={
                        getValues("rooms") === undefined
                          ? ""
                          : getValues("rooms")
                      }
                      onChange={(e) => {
                        let roomCount = e.target.value
                          ? parseInt(e.target.value)
                          : undefined;
                        setValue("rooms", roomCount);
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <CustomStaticSelect
                      label="Category"
                      name="category"
                      id="hotel_category"
                      className="py-2"
                      labelClassname="text-secondary"
                      register={register}
                      optionArr={[
                        {
                          value: "All",
                        },
                        {
                          value: "3 star",
                        },
                        {
                          value: "4 star",
                        },
                        {
                          value: "5 star",
                        },
                      ]}
                    />
                  </div>
                </div>
              </AdultChildDetails>
            </div>
          </div>
          <LoadingButton loading={requestLoading} btnType="submit">
            {isUpdating ? "Update " : "Save "}Enquiry
          </LoadingButton>
        </form>

        <CreateNewAgent
          handleModalClose={() => {
            setShowCreateNewUserPopUp(false);
          }}
          isModalOpen={showCreateNewUserPopUp}
          url="/query/saveHotelEnquiry"
          queryData={{
            ...formData,
            checkin: moment(formData.checkin).format("YYYY-MM-DD"),
            checkout: moment(formData.checkout).format("YYYY-MM-DD"),
          }}
          changeQueryData={() => {
            setValue("remark", undefined);
            reset(defaultValues);
          }}
        />
        {/* {!isLoogedIn && (
          <ReCaptcha
            setToken={(token: string) => {
              setCaptchaToken(token);
            }}
            myRef={reCaptchaRef}
          />
        )} */}
      </div>
    </>
  );
};
export default HotelsQueryForm;
